import { create } from 'zustand'
import type { Photo } from 'types/globalTypes'
import cardImg from 'assets/Images/ImageCard1.png'

const webConent = (set: any) => ({
  // Slides array used by the carousel renderer
  slides: [] as Array<{
    id: string | number
    content: {
      heading: string
      headingBefore: string
      headingColored: string
      headingAfter: string
      description: string
      buttonText: string
      buttonLink: string
    }
    type: 'none' | 'commonEvent' | 'image' | 'video'
    videoLink?: string
    imageLink?: string
    commonEventId?: string
    event?: any
    gallery: string[] | undefined
    galleryIds?: {
      imageIndex: number
      imageId: string
    }[]
  }>,
  setSlides: (
    slides: Array<{
      id: string | number
      content: {
        heading: string
        headingBefore: string
        headingColored: string
        headingAfter: string
        description: string
        buttonText: string
        buttonLink: string
      }
      // card: { type: 'none' | 'event' | 'video'; videoUrl?: string; event?: any }
      type: 'none' | 'commonEvent' | 'image' | 'video'
      videoLink?: string
      imageLink?: string
      commonEventId?: string
      event?: any
      gallery: string[]
      galleryIds?: {
        imageIndex: number
        imageId: string
      }[]
    }>,
  ) => set({ slides }),

  // Currently focused slide index across editor and preview
  currentSlide: 0 as number,
  setCurrentSlide: (index: number) =>
    set(() => ({ currentSlide: Math.max(0, index) })),

  // Add a new slide with initial values
  addSlide: () =>
    set((state: any) => ({
      slides: [
        ...state.slides,
        {
          id: `local-${Date.now()}`,
          content: {
            heading: 'Enter text',
            headingBefore: 'Title beofre',
            headingColored: 'Title colored',
            headingAfter: 'Title after',
            description: 'Few words about the external',
            buttonText: 'Learn more',
            buttonLink: '#',
          },
          type: 'none',
          gallery: [],
          galleryIds: [],
        },
      ],
    })),

  // Update only content fields for a specific slide
  updateSlideContent: (
    slideId: string | number,
    contentUpdate: Partial<{
      id?: string | number
      heading: string
      headingBefore: string
      headingColored: string
      headingAfter: string
      description: string
      buttonText: string
      buttonLink: string
      type: 'none' | 'commonEvent' | 'image' | 'video'
      videoLink?: string
      imageLink?: string
      commonEventId?: string
      event?: {
        name: string
        coverPhoto: string
        date: string
        venue: string
      }
      gallery: string[]
      galleryIds?: {
        imageIndex: number
        imageId: string
      }[]
    }>,
  ) =>
    set((state: any) => ({
      slides: state.slides.map((s: any) =>
        s.id === slideId
          ? {
              ...s,
              id: contentUpdate.id ?? s.id,
              content: {
                ...s.content,
                ...contentUpdate,
              },
              type: contentUpdate.type ?? s.type,
              videoLink: contentUpdate.videoLink ?? s.videoLink,
              imageLink: contentUpdate.imageLink ?? s.imageLink,
              commonEventId: contentUpdate.commonEventId ?? s.commonEventId,
              event: contentUpdate.event ?? s.event,
              gallery: contentUpdate.gallery ?? s.gallery,
              galleryIds: contentUpdate.galleryIds ?? s.galleryIds,
            }
          : s,
      ),
    })),

  // Remove slide by id
  removeSlide: (slideId: string | number) =>
    set((state: any) => ({
      slides: state.slides.filter((s: any) => s.id !== slideId),
    })),

  heading: 'Enter text',
  setHeading: (state: string) => set({ heading: state }),
  headingBefore: 'Title beofre',
  setHeadingBefore: (state: string) => set({ headingBefore: state }),
  headingColored: 'Title colored',
  setHeadingColored: (state: string) => set({ headingColored: state }),
  headingAfter: 'Title after',
  setHeadingAfter: (state: string) => set({ headingAfter: state }),
  description: 'Few words about the external',
  setDescription: (state: string) => set({ description: state }),
  buttonText: 'Learn more',
  setButtonText: (state: string) => set({ buttonText: state }),
  buttonLink: '#',
  setButtonLink: (state: string) => set({ buttonLink: state }),

  gallery: {} as { [index: number]: { id?: string; photo?: Photo } },
  setGalleryId: (index: number, id: string | undefined) =>
    set((state: any) => ({
      gallery: {
        ...state.gallery,
        [index]: { ...(state.gallery?.[index] || {}), id },
      },
    })),
  setGalleryPhoto: (index: number, photo: Photo | undefined) =>
    set((state: any) => ({
      gallery: {
        ...state.gallery,
        [index]: { ...(state.gallery?.[index] || {}), photo },
      },
    })),
  type: 'none',
  setType: (state: 'none' | 'commonEvent' | 'image' | 'video') =>
    set({ type: state }),
  videoLink: undefined,
  setVideoLink: (state: string) => set({ videoLink: state }),
  imageLink: undefined,
  setImageLink: (state: string) => set({ imageLink: state }),
  commonEventId: undefined,
  setCommonEventId: (state: string) => set({ commonEventId: state }),
  clearGallery: () => set({ gallery: {} }),

  //modals
  reorderSlidesModal: false,
  setReorderSlidesModal: (state: boolean) => set({ reorderSlidesModal: state }),
})

export const webContentStore = create(webConent)
